export default {"src":"/_next/static/media/discord.68dfa2f6.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};